global.footnotes = (function () {

	var updateFootnotes = function () {
		var footnoteRefs = document.querySelectorAll('.report-footnote-ref:not(.js-footnote--loaded)');

		if (footnoteRefs.length > 0) {
			for (var i = 0; i < footnoteRefs.length; i++) {
				footnoteRefs[i].classList.add('js-footnote--loaded');

				footnoteRefs[i].addEventListener('click', function (e) {
					e.preventDefault();
					var footnote = document.querySelector(this.getAttribute('href'));
					footnote.classList.toggle('show');
					footnote.focus();
				});
			}
		}
	};

	return {
		updateFootnotes: updateFootnotes
	};
})();
